'use client';

import { useModals } from '@/contexts/ModalContext';
import { IconX } from '@tabler/icons-react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { Link } from '@/app/[lang]/(main)/components/shared/PrivateLink/ServerLink';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

export const AppPromotionModal = () => {
  const modals = useModals();
  const t = useTranslations('controls');
  const onClose = () => modals.close(`app-promotion-modal`);

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        showCloseButton={false}
        aria-describedby={undefined}
        className='flex gap-0 p-0 border-0 w-[990px] max-w-[calc(100vw-2rem)] sm:max-w-[990px] bg-white rounded-[24px] overflow-hidden'
      >
        <Button
          variant='ghost'
          size='icon'
          onClick={onClose}
          className='absolute top-[20px] end-[20px] size-[28px] hover:bg-transparent'
        >
          <IconX className='text-text-primary' />
        </Button>

        <Image alt='' width={497} height={800} src='/assets/images/promote-application.png' />
        <div className='w-full h-[800px] flex flex-col justify-center ps-[32px]'>
          <DialogTitle className='text-[32px] font-semibold tracking-[-0.64px] leading-[normal] text-primary'>
            {t('appPromotion.description')}
          </DialogTitle>

          <summary className='flex flex-col gap-[24px] mt-[32px] w-[77%]'>
            <div className='flex gap-[12px] items-center'>
              <div className='w-[60px] h-[60px] flex items-center justify-center bg-surface-lightest rounded-[50%] text-[24px]'>
                💎
              </div>
              <div className='text-[16px] font-normal leading-[20px]'>{t('appPromotion.benefits.publishFree')}</div>
            </div>

            <div className='flex gap-[12px] items-center'>
              <div className='w-[60px] h-[60px] flex items-center justify-center bg-surface-lightest rounded-[50%] text-[24px]'>
                💎
              </div>
              <div className='text-[16px] font-normal leading-[20px]'>{t('appPromotion.benefits.callSellers')}</div>
            </div>

            <div className='flex gap-[12px] items-center'>
              <div className='w-[60px] min-w-[60px] h-[60px] flex items-center justify-center bg-surface-lightest rounded-[50%] text-[24px]'>
                💎
              </div>
              <div className='text-[16px] font-normal leading-[20px]'>{t('appPromotion.benefits.manageProfile')}</div>
            </div>
          </summary>

          <div className='mt-[56px] flex gap-[7px]'>
            <Button
              variant='default'
              className='rounded-[12px] w-[180px] h-[48px] gap-[5px] bg-text-primary hover:bg-text-primary'
            >
              <Image src='/assets/icons/icon-apple.svg' height={32} width={32} alt='apple' />
              <div>
                <div className='text-[12px] font-normal text-white'>{t('appPromotion.downloadIn')}</div>
                <div className='text-[16px] font-medium text-white'>{t('appPromotion.appStore')}</div>
              </div>
            </Button>

            <Link
              target='_blank'
              rel='noopener roreferrer'
              href='https://play.google.com/store/apps/details?id=com.doska.tv'
              className='rounded-[12px] w-[180px] h-[48px] bg-text-primary flex gap-[5px] items-center justify-center'
            >
              <Image src='/assets/icons/icon-google.svg' height={32} width={32} alt='google' />
              <div>
                <div className='text-[12px] font-normal text-white'>{t('appPromotion.downloadIn')}</div>
                <div className='text-[16px] font-medium text-white'>{t('appPromotion.googlePlay')}</div>
              </div>
            </Link>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
